// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__63K06","load8":"Spinner_load8__JbkmN"};